import { BodyText } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import Modal from 'components/Modal';

import {
  NAME,
  OWN_OCCUPATION_COVERAGE_CONTENT,
  RESIDUAL_DISABILITY_COVERAGE_CONTENT,
  TITLE,
} from './constants';
import styles from './styles';

const useStyles = createUseStyles(styles);

const LearnMoreModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal(state: boolean): void;
}) => {
  const classes = useStyles();
  const closeModal = () => setShowModal(false);

  return (
    <Modal
      title={TITLE}
      primaryCTA={{ text: 'Acknowledge', onClick: closeModal }}
      name={NAME}
      onRequestClose={closeModal}
      showModal={showModal}
    >
      <BodyText className={classes.content}>
        More detail on how these features enhance the protection of a long-term disability policy.
      </BodyText>
      <BodyText className={classes.content}>
        <BodyText as="strong" size="inherit" weight="bold">
          Own occupation coverage
        </BodyText>
        {' - '}
        {OWN_OCCUPATION_COVERAGE_CONTENT}
      </BodyText>
      <BodyText className={classes.content}>
        <BodyText as="strong" size="inherit" weight="bold">
          Residual disability coverage
        </BodyText>
        {' - '}
        {RESIDUAL_DISABILITY_COVERAGE_CONTENT}
      </BodyText>
    </Modal>
  );
};

export default LearnMoreModal;
